import "./slider.css";

import React from "react";

//Horizontal row that scrolls a page at a time with the arrows (and swipes / scrolls natively on touch screens)
const Slider = ({ label, className = "", children }) => {
  const trackRef = React.useRef(null);
  const [canScroll, setCanScroll] = React.useState({ back: false, next: false });

  const updateArrows = React.useCallback(() => {
    const track = trackRef.current;
    if (!track) {
      return;
    }
    setCanScroll({
      back: track.scrollLeft > 4,
      next: track.scrollLeft + track.clientWidth < track.scrollWidth - 4,
    });
  }, []);

  React.useEffect(() => {
    updateArrows();
    const track = trackRef.current;
    window.addEventListener("resize", updateArrows);
    track.addEventListener("scroll", updateArrows, { passive: true });
    return () => {
      window.removeEventListener("resize", updateArrows);
      track.removeEventListener("scroll", updateArrows);
    };
  }, [updateArrows, children]);

  const scroll = (direction) => {
    const track = trackRef.current;
    track.scrollBy({ left: direction * track.clientWidth, behavior: "smooth" });
  };

  return (
    <div
      className={`slider ${className}`}
      role={"region"}
      aria-label={label}
    >
      <button
        type={"button"}
        className={"slider-arrow is-back"}
        onClick={() => scroll(-1)}
        disabled={!canScroll.back}
        aria-label={"Previous"}
      >
        <svg
          viewBox={"0 0 12 22"}
          aria-hidden={"true"}
        >
          <path d={"M11 1L1 11l10 10"} />
        </svg>
      </button>
      <ul
        ref={trackRef}
        className={"slider-track"}
      >
        {React.Children.map(children, (child) => (
          <li className={"slider-item"}>{child}</li>
        ))}
      </ul>
      <button
        type={"button"}
        className={"slider-arrow is-next"}
        onClick={() => scroll(1)}
        disabled={!canScroll.next}
        aria-label={"Next"}
      >
        <svg
          viewBox={"0 0 12 22"}
          aria-hidden={"true"}
        >
          <path d={"M1 1l10 10L1 21"} />
        </svg>
      </button>
    </div>
  );
};

export default Slider;
